const Languages = {
  Spanish: 'es',
  English: 'en',
}
export { Languages }
